export async function submitToJotForm(formData: {
  firstName: string;
  lastName: string;
  email: string;
  date: string;
}) {
  // NOTE: JotForm submission path retained below for reference but disabled per request.
  // const API_BASE = (import.meta.env as any)?.VITE_JOTFORM_API_BASE || 'https://eu-api.jotform.com';
  // const API_KEY = import.meta.env.VITE_JOTFORM_API_KEY as string | undefined;
  // const FORM_ID = import.meta.env.VITE_JOTFORM_FORM_ID as string | undefined;
  // const FIELD_FIRST_NAME = import.meta.env.VITE_FIELD_FIRST_NAME as string | undefined;
  // const FIELD_LAST_NAME = import.meta.env.VITE_FIELD_LAST_NAME as string | undefined;
  // const FIELD_EMAIL = import.meta.env.VITE_FIELD_EMAIL as string | undefined;
  // const FIELD_DATE = import.meta.env.VITE_FIELD_DATE as string | undefined;
  // if (!API_KEY || !FORM_ID || !FIELD_FIRST_NAME || !FIELD_LAST_NAME || !FIELD_EMAIL || !FIELD_DATE) {
  //   throw new Error(
  //     "Missing JotForm environment variables. Ensure VITE_JOTFORM_API_KEY, VITE_JOTFORM_FORM_ID, VITE_FIELD_FIRST_NAME, VITE_FIELD_LAST_NAME, VITE_FIELD_EMAIL, and VITE_FIELD_DATE are set."
  //   );
  // }
  // const payload = new FormData();
  // payload.append(`submission[${FIELD_FIRST_NAME}]`, formData.firstName);
  // payload.append(`submission[${FIELD_LAST_NAME}]`, formData.lastName);
  // payload.append(`submission[${FIELD_EMAIL}]`, formData.email);
  // payload.append(`submission[${FIELD_DATE}]`, formData.date);
  // const response = await fetch(
  //   `${API_BASE.replace(/\/$/, '')}/form/${encodeURIComponent(FORM_ID)}/submissions?apiKey=${encodeURIComponent(API_KEY)}`,
  //   { method: "POST", body: payload }
  // );
  // if (!response.ok) {
  //   const errorText = await response.text().catch(() => "");
  //   throw new Error(`JotForm submission failed (${response.status}): ${errorText}`);
  // }
  // const json = await response.json();
  // if (json?.responseCode !== 200 || json?.message?.toLowerCase?.() !== 'success') {
  //   throw new Error(`JotForm responded without success: ${JSON.stringify(json)}`);
  // }
  // return json;

  // New behavior: send details to email via serverless endpoint
  const EMAIL_ENDPOINT = (import.meta.env as any)?.VITE_EMAIL_ENDPOINT || '/api/send-email';
  const resp = await fetch(EMAIL_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      date: formData.date,
      source: 'checkout-modal'
    })
  });
  if (!resp.ok) {
    const txt = await resp.text().catch(() => '');
    throw new Error(`Email submission failed (${resp.status}): ${txt}`);
  }
  return resp.json().catch(() => ({ ok: true }));
}
